import React, { useEffect, useState } from 'react';

// styles

import { CarrierResponse, CreateCarrierData } from '../../redux/api/carriers/carriers.model';
import { useUpdateCarrierMutation } from '../../redux/api/carriers/carrierApi';
import useNotifications from '../../providers/Notifications/Notifications.provider';
import { TwButton, TwButtonType } from '../../components/TwButtons/TwButtons';
import TwDialog from '../../components/TwDialog/TwDialog';
import TwField, { TwInputTypes } from '../../components/TwFields/TwFields';
import { Characters, useUnformatValue } from '../../hooks/useAllowCharacters';

export interface CarrierEditNotesProps {
  open: boolean;
  carrier: CarrierResponse;
  onClose: () => void;
}

const TwCarrierEditNotes: React.FC<CarrierEditNotesProps> = ({
  open,
  carrier,
  onClose
}): JSX.Element => {
  const { addNotification } = useNotifications();

  const [notes, setNotes] = useState<string | undefined>('');
  const [updateCarrier] = useUpdateCarrierMutation();
  const unformatString = useUnformatValue(Characters.number);

  const updateNote = (): void => {
    const params: CreateCarrierData & { id: string } = {
      ...carrier,
      phone: unformatString(carrier.phone || ''),
      locationId: carrier.location?.id || undefined,
      phone_ext: carrier.phone_ext || undefined,
      mcNumber: carrier.mc_number || undefined,
      taxId: carrier.tax_id || undefined,
      externalCompanyId: carrier.external_company_id || undefined,
      payTo: carrier.pay_to || undefined,
      email: carrier.email_address || undefined,
      pocFirstname: carrier.first_name || undefined,
      pocLastname: carrier.last_name || undefined,
      payRate: carrier.pay_rate || undefined,
      defaultPayRateType: carrier.default_pay_rate_type || undefined,
      notes: notes
    };

    updateCarrier(params)
      .unwrap()
      .then(async () => {
        addNotification({
          message: 'Carrier notes updated successfully',
          variant: 'success'
        });

        handleClose();
      })
      .catch((error: any) => {
        addNotification({
          message: error.message,
          variant: 'error'
        });
      });
  };

  const handleClose = (): void => {
    setNotes('');
    onClose();
  };

  const DialogActions = (): JSX.Element[] => {
    const dialogActions = [
      <TwButton
        key="1"
        fullwidth={false}
        type={TwButtonType.secondary}
        label="Cancel"
        action={(): void => {
          handleClose();
        }}
      />,
      <TwButton
        key="2"
        fullwidth={false}
        type={TwButtonType.primary}
        label="Confirm"
        action={updateNote}
      />
    ];

    return dialogActions;
  };

  useEffect(() => {
    if (carrier.notes && open) {
      setNotes(carrier.notes);
    }
  }, [open]);

  return (
    <>
      <TwDialog
        open={open}
        onClickClose={(): void => {
          handleClose();
        }}
        size="sm"
        title="Edit note"
        actions={DialogActions()}
        draggable={true}
      >
        <div className="edit-notes__wrapper tid-edit-notes__wrapper">
          <div className="edit-notes__form-section">
            <div className="edit-notes__inputs-container tid-edit-notes__notes">
              <TwField
                id="notes"
                name="notes"
                label="Notes"
                inputType={TwInputTypes.text}
                value={notes}
                onInputChange={(e): void => {
                  setNotes(e.target.value);
                }}
                className="edit-notes__inputs-container__notes"
              />
            </div>
          </div>
        </div>
      </TwDialog>
    </>
  );
};

export default TwCarrierEditNotes;
